module.exports = __webpack_public_path__ + "static/espen-a0d13a567f067a5868d69d7a21705aae.jpg";